var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "body", locale: _vm.$root.$i18n.locale } },
    [
      _c(
        "nav",
        {
          staticClass:
            "app-nav navbar mortgage-application-navbar p-0 app-standalone",
          class: { "side-right offset-lg-2": _vm.showSidebar },
          attrs: { id: "client-app-nav" },
        },
        [_vm._t("topbar", null, { showSidebar: _vm.showSidebar })],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated slideInLeft",
            "leave-active-class": "animated slideOutLeft",
          },
        },
        [
          _vm.showSidebar
            ? _c(
                "nav",
                {
                  staticClass:
                    "side-left fixed-left navbar-collapse app-navigation",
                  attrs: { id: "sidebar", "aria-label": "nav" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "h-100 w-100 position-relative" },
                    [_vm._t("sidebar")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "collapse-sidebar-button d-none d-md-block",
                      on: { click: _vm.toggleSidebar },
                    },
                    [
                      _c("icon", {
                        staticClass: "text-primary",
                        attrs: { name: "chevron-left" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "app-standalone",
          class: { "side-right offset-lg-2": _vm.showSidebar },
          attrs: { id: "page" },
        },
        [
          _c(
            "div",
            { staticClass: "py-5", attrs: { id: "main-content" } },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }